import {RequestStatus} from 'src/openapi/admin/models/RequestStatus';

const REQUEST_STATUS_DISPLAY: Record<RequestStatus, string> = {
    [RequestStatus.DECLINED]: 'Denied',
    [RequestStatus.APPROVED]: 'Approved',
    [RequestStatus.CREATED]: 'Pending',
};

export const getDisplayStatus = (status: RequestStatus): string => {
    return REQUEST_STATUS_DISPLAY[status];
};
